import { Box, CircularProgress } from '@mui/material'
import React from 'react'

interface LoadingProps {
  height?: string
}

const Loading: React.FC<LoadingProps> = ({ height }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: height || '90vh' }}>
      <CircularProgress
        color='primary'
        size={32}
      />
    </Box>
  )
}

export default Loading
